import React from 'react';

const Loader = () => (
  <div className="liveblog-loader">
    <div className="liveblog-loader-bounce1"></div>
    <div className="liveblog-loader-bounce2"></div>
  </div>
);

export default Loader;
